<template>
  <div class="content">
    <!-- 搜索区域start -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div" >
            <span style="color: red">*</span>选择任务
          </div>
          <el-select
            size="mini"
            class="ipt-sty"
            v-model="page.taskDetailGuid"
            placeholder="请选择"
            collapse-tags
            reserve-keyword
            clearable
            filterable
            multiple
            @change="taskChange"
          >
            <el-option
              v-for="item in taskList"
              :key="item.guid"
              :label="item.label"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">
            <span style="color: red">*</span>选择问卷
          </div>
          <el-select
            size="mini"
            class="ipt-sty"
            v-model="page.surveyTenantGuid"
            filterable
            @focus="selectSurveyFocus"
            placeholder="请选择"
          >
            <el-option
              v-for="item in surveyList"
              :key="item.guid"
              :label="item.surveyTitle"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="6"
          ><div class="search-area-div" >填写时间</div>
          <el-date-picker
            size="mini"
            v-model="timeRange"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="截止时间"
            value-format="yyyy-MM-dd"
            class="ipt-sty"
          >
          </el-date-picker>
        </el-col> -->
        <el-col :span="6">
            <div class="search-area-div">账单周期</div>
            <el-select
              size="mini"
              v-model="page.billCycle"
              class="ipt-sty"
              placeholder="请选择"
              filterable
              clearable
              multiple
              @change="refreshData"
              @focus="selectSurveyFocus"
            >
              <el-option v-for="item in billCycleData" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="expand" @click="searchShow = !searchShow"
            ><i :class="searchShow ? 'el-icon-arrow-up mr5' : 'el-icon-arrow-down mr5'"></i
            >{{ searchShow ? '收起筛选' : '更多筛选' }}</el-button
          >
          <el-button size="mini" type="info" @click="goSearch">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
        <!-- <el-col :span="23" class="t-right mt15">
          <el-button size="medium" type="info" @click="goSearch">搜索</el-button>
          <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
        </el-col> -->
      </el-row>
      <el-row :gutter="24">
        <div class="search-block mt15" v-if="searchShow">
          
          <el-col :span="6">
            <div class="search-area-div" >是否过滤任务</div>
            <el-select size="mini" class="ipt-sty" v-model="page.billCycleTaskValid" @change="refreshTask" placeholder="请选择" filterable>
              <el-option v-for="item in getCodeListByKey('是否')" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div" >是否结算</div>
            <el-select size="mini" class="ipt-sty" v-model="page.settleState" placeholder="请选择" filterable>
              <el-option v-for="item in settleOp" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div" >
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">若为是，单选题的比例之和为100%;<br/>若为否，则不做调差处理，比例之和可能不为100%</div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              比例调整</div>
            <el-select size="mini" class="ipt-sty" v-model="page.rateAdjust" placeholder="请选择" filterable>
              <el-option v-for="item in getCodeListByKey('是否')" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </div>
      </el-row>
    </div>
    <!-- 搜索区域end -->

    <el-tabs class="process-list" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="问卷分析" name="1"></el-tab-pane>
      <el-tab-pane label="调查明细" name="2"></el-tab-pane>
    </el-tabs>
    <!-- 内容区域start -->
    <template v-if="activeName === '1'">
      <QuestionnaireAnalysis
        :surveyReport="surveyReport"
        :taskDetail="surveyReportTaskDetail"
        :currentSurver="currentSurver"
        :tableDataAll="tableDataAll"
        :element-loading-text="'报告表格生成中，请勿关闭当前浏览器'"
        @goBack="goBack"
        :surveyReportLoading="surveyReportLoading"
        v-loading="surveyReportLoading"
      ></QuestionnaireAnalysis>
      <!-- 问卷分析 -->
      <div class="no-data" v-if="surveyReport.length == 0">
        <img src="../../assets/images/no_data.png" alt="" />
      </div>
    </template>

    <template v-if="activeName === '2'">
      <!-- 调查明细 -->
      <div class="button-area">
        <!-- <el-button size="medium" type="info" @click="toImport">批量导入</el-button> -->
        <el-button size="medium" type="info" @click="report">批量导出</el-button>
        <!-- <el-button size="medium" type="info" @click="reportTopic">导出题目</el-button> -->
      </div>
      <div class="back-color-fff p16">
        <el-table :data="tableData.data && tableData.data.records" border style="width: 100%" v-loading="tableLoading">
          <el-table-column label="序号" width="60" header-align="center" align="center" v-if="tableData.columns">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            min-width="180"
            :label="item"
            show-overflow-tooltip
            header-align="center"
            align="left"
            v-for="(item, index) in tableData.columns"
            :key="index"
          >
            <template slot-scope="scope">{{ scope.row['column_' + index] || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </template>
    <!-- 内容区域end -->
  </div>
</template>

<script>
import QuestionnaireAnalysis from './components/QuestionnaireAnalysis.vue';
import { route } from '@/api/apiRoute';
import store from '@/store';
import qs from 'qs';
import { $eventBus } from './utils/eventBus';
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
export default {
  components: {
    QuestionnaireAnalysis,
  },
  mixins:[getTenantDetail],
  data() {
    return {
      ServiceProviderTypeEnum,
      searchShow: false,
      checkboxGroupList: [],
      activeName: '1',
      fullscreenLoading: false,
      timeRange: [],
      tableLoading: false,
      page: {
        settleState:null,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        surveyTenantGuid: null,
        tenantGuid: '',
        staffGuid: '',
        startTime: '',
        endTime: '',
        taskDetailGuid: [],
        billCycle: [],
        accountMonth: '',
        billCycleTaskValid:'N',
        rateAdjust:'N',
      },
      currentSurver: {}, // 当前问卷item
      surveyList: [],
      surveyReport: [], // 问卷分析导出的内容
      surveyReportTaskDetail:[],// 问卷分析导出的内容的任务明细
      surveyGuid: null,
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      tableDataAll: null,
      dialogVisible: false,
      taskGuid: '',
      taskList: [],
      selectTask: [],
      organisationGuid: null,
      tenantGuid: null,
      taskMainGuids: [], // 任务id
      billCycleData: [], // 账单周期列表
      accountMonth: '',
      //批量导入
      showImport: false,
      currentStep: 0,
      importResult: '',
      importLoading: false,
      surveyReportLoading: false,
      fileList: [], //上传的文件
      settleOp:[
        {
          label:'全部',
          value:null
        },
        {
          label:'是',
          value:'Y'
        },
        {
          label:'否',
          value:'N'
        }
      ]
    };
  },
  async created() {
    // this.getList();
   await this.Mixins_getServiceProviderType();
    this.getTaskList();
    // this.getSurveyList();
  },
  watch: {},
  computed: {
    /**是否是 三方接包服务商 */
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    toImport() {
      this.$router.push(
        '/surveyExport?productGuid=' +
          this.$route.query.productGuid +
          '&guid=' +
          this.page.taskDetailGuid +
          '&surveyGuid=' +
          this.page.surveyTenantGuid,
      );
    },
    //获取任务
    getTaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        taskContentType: ['WJDC'],
        serviceTenantGuid: localStorage.guid,
      };
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/task/data/get/tenant-task-detail-list`, query)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.taskList = res.data.data && res.data.data.records ? res.data.data.records : [];
            this.taskList = this.taskList.map(item => {
              let label = item.taskTitle + ' | ' + item.taskContentName;
              // 三方接包服务商使用此标题
              if (this.isThirdPartyContractor) {
                label = item.taskTitleOrganisation + ' | ' + item.taskContentName;
              }
              return {
                ...item,
                label,
              }
            })
            if (this.taskList.length > 0) {
              this.page.taskDetailGuid = [this.taskList[0].guid]; // 多选设置
              this.organisationGuid = [this.taskList[0].organisationGuid]; // 多选设置
              // if (this.taskList[0].newServiceTenantGuid) {
              //   this.tenantGuid = this.taskList[0].newServiceTenantGuid;
              // } else {
              //   this.tenantGuid = this.taskList[0].tenantGuid;
              // }
              this.tenantGuid = this.taskList[0].tenantGuid;
              this.taskChange(this.page.taskDetailGuid);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //获取问卷列表
    getSurveyList() {
      this.tableLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        pageIndex: 1,
        pageSize: -1,
        // organisationGuid: this.organisationGuid,
        tenantGuid: this.tenantGuid,
        taskDetailGuids: this.page.taskDetailGuid,
      };
      this.api.postJson(`/${serverConfig.msSalesPerformService}/survey/report/get-by-task`, query).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.length > 0) {
            this.surveyList = res.data.data;
            this.page.surveyTenantGuid = this.surveyList[0].guid;
            // this.getList();
            // this.getListAll();
          } else {
            this.surveyList = [];
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取周期计算
    async getCycleDataList() {
      let accountMonth = await this.getAccountMonth();
      this.accountMonth = accountMonth || [];
      let param = {
        tenantGuid: this.tenantGuid,
        accountMonth: this.accountMonth,
      };
      // 此处已选的 selectTask 里面的 tenantGuid 一定是相同的 
      // 但是 newServiceTenantGuid 可能不同
      // 如果 第一个 newServiceTenantGuid 有值
      // 默认直接取第一个 不考虑 不相同情况
      // 本质业务上如此操作就是错误的
      if (this.selectTask[0]?.newServiceTenantGuid) {
        param.tenantGuid = this.selectTask[0].newServiceTenantGuid;
      }
      // 是三方接包服务商
      if (this.isThirdPartyContractor) {
        param.tenantGuid = localStorage.guid;
      }
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-bill-cycle-by-months`, param)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.billCycleData = res.data.data || [];
            if (this.billCycleData && this.billCycleData.length > 0) {
              this.billCycleData.forEach((i, index) => {
                if (!i) {
                  this.billCycleData[index] = '全部';
                }
              });
            }
            console.log('this.',this.billCycleData);

          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getAccountMonth() {
      let query = {
        tenantGuid: this.tenantGuid,
        taskDetailGuids: this.page.taskDetailGuid,
      };
      return new Promise((resolve, reject) => {
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/survey/report/account-month/get-by-task`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              resolve(res.data.data);
            } else {
              reject(null);
              this.$message.error(res.data.msg);
            }
          });
      });
    },
    taskChange(guidList) {
      // 获取相同公司的任务
      if (guidList && guidList.length) {
        this.taskMainGuids = [];
        this.selectTask = [];
        guidList.forEach((i) => {
          let oneTask = this.taskList.find((item) => item.guid === i);
          if (oneTask) this.selectTask.push(oneTask);
        });
        this.tenantGuid = this.selectTask[0] && this.selectTask[0].tenantGuid ? this.selectTask[0].tenantGuid : '';
        if (!this.selectTask.every((item) => this.tenantGuid === item.tenantGuid)) {
          this.$message.error('请选择相同公司');
          this.page.taskDetailGuid.pop();
          return;
        }
        this.selectTask.forEach((item) => {
          this.taskMainGuids.push(item.taskMainGuid);
        });
        this.billCycleData = [];
        this.page.billCycle = [];
        this.page.accountMonth = '';
        this.page.surveyTenantGuid = null;
        this.page.billCycleTaskValid = 'N';
        this.page.rateAdjust = 'N';
        this.getCycleDataList(); // 获取账单周期
        this.getSurveyList();
        this.$forceUpdate();
      }
    },
    selectSurveyFocus() {
      if (!this.page.taskDetailGuid.length) {
        this.$message.error('请先选择任务！');
      }
    },
    refreshData(val) {
      if (val) {
        console.log('val',val);
        let idx=val.findIndex(item=>item=='全部')
        if(this.page.billCycleTaskValid=='Y'&&(val.length<1||idx>-1)){
          this.$message.warning('必须先选择账单周期且账单周期不为全部时才可过滤任务');
          this.page.billCycleTaskValid='N'
        }
        this.page.accountMonth = this.accountMonth;
      }
      this.$forceUpdate();
    },
    refreshTask(val) {
      if (val=='Y') {
        let idx=this.page.billCycle.findIndex(item=>item=='全部')
        if(this.page.billCycle.length<1||idx>-1){
          this.$message.warning('必须先选择账单周期且账单周期不为全部时才可过滤任务');
          this.page.billCycleTaskValid='N'
        }
      }
      this.$forceUpdate();
    },
    selectSurveyChange() {
      if (this.page.surveyTenantGuid) {
        this.currentSurver = this.surveyList.find((item) => item.guid === this.page.surveyTenantGuid);
      }
    },
    goSearch() {
      if (!this.surveyList.length) {
        this.$message.error('请选择任务与问卷！');
        return;
      }
      if (!this.page.surveyTenantGuid && (!this.page.taskDetailGuid||this.page.taskDetailGuid.length<1)) {
        this.$message.error('请选择任务与问卷！');
        return;
      }
      this.getList();
      this.getListAll();
      if (this.activeName === '1') {
        let activeName = this.activeName;
        this.activeName = '';
        this.$nextTick(() => {
          this.activeName = '1';
          this.$nextTick(() => {
            localStorage.setItem('checkboxGroupList', JSON.stringify([]));
            $eventBus.$emit('setCheckGroup', { checkboxGroupList: [] });
            this.getSurveyReport();
            this.getSurveyTaskDetail();
          });
        });
      } else {
        this.getSurveyReport();
        this.getSurveyTaskDetail();
      }
    },
    getSurveyReport() {
      if(!this.page.taskDetailGuid||this.page.taskDetailGuid.length<1){
        this.$message.error('请选择任务')
        return
      }
      this.surveyReportLoading = true;
      let {settleState} = this.page
      let param = {
        settleState,
        surveyTenantGuid: this.page.surveyTenantGuid,
        accountMonth: this.accountMonth,
        tenantGuid: this.tenantGuid,
        curTenantGuid: localStorage.guid,
        taskDetailGuid: this.page.taskDetailGuid,
        billCycleTaskValid: this.page.billCycleTaskValid,
        rateAdjust: this.page.rateAdjust,
      };
      if (this.page.billCycle.length) {
        param.billCycle = this.page.billCycle.find((item) => item === '全部') ? [] : this.page.billCycle;
      } else {
        param.billCycle = [];
      }
      if (Array.isArray(this.timeRange) && this.timeRange.length > 0) {
        param.startTime = `${this.timeRange[0]} 00:00:00`;
        param.endTime = `${this.timeRange[1]} 00:00:00`;
      }
      this.selectSurveyChange(); // 获取问卷名称
      this.api
        .postJson(`/${serverConfig.msBizdataStatisticsService}/survey/data/get-survey-report `, param)
        .then((res) => {
          this.surveyReportLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.surveyReport = res.data.data || [];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.surveyReportLoading = false;
        });
    },
    getSurveyTaskDetail() {
      if(!this.page.taskDetailGuid||this.page.taskDetailGuid.length<1)return
      this.surveyReportLoading = true;
      let param = {
        surveyTenantGuid: this.page.surveyTenantGuid,
        guids: this.page.taskDetailGuid,
      };
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/task/get-task-detail-list`, param)
        .then((res) => {
          this.surveyReportLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.surveyReportTaskDetail = res.data.data || [];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.surveyReportLoading = false;
        });
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      if (Array.isArray(this.timeRange) && this.timeRange.length > 0) {
        this.page.startTime = this.timeRange[0];
        this.page.endTime = this.timeRange[1];
      } else {
        this.page.startTime = ''
        this.page.endTime = ''
      }
      let param = JSON.parse(JSON.stringify(this.page));
      if (this.page.billCycle.length) {
        param.billCycle = this.page.billCycle.find((item) => item === '全部') ? [] : this.page.billCycle;
      } else {
        param.billCycle = [];
      }
      param.taskDetailGuidList = param.taskDetailGuid;
      param.accountMonth = this.accountMonth;
      param.taskTenantGuid = this.tenantGuid;
      param.isEncrypt = 'Y';
      param.tenantGuid = this.tenantGuid;
      param.curTenantGuid = localStorage.guid;
      delete param.taskDetailGuid;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/survey/report/survey-staff-page-list`, param)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data;
            self.page.totalPage = res.data.data.data.totalPages;
            self.page.totalRows = res.data.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getListAll() {
      let self = this;

      self.tableLoading = true;
      if (Array.isArray(this.timeRange) && this.timeRange.length > 0) {
        this.page.startTime = this.timeRange[0];
        this.page.endTime = this.timeRange[1];
      } else {
        this.page.startTime = ''
        this.page.endTime = ''
      }
      let param = JSON.parse(JSON.stringify(this.page));
      if (this.page.billCycle.length) {
        param.billCycle = this.page.billCycle.find((item) => item === '全部') ? [] : this.page.billCycle;
      } else {
        param.billCycle = [];
      }
      param.taskDetailGuidList = param.taskDetailGuid;
      param.accountMonth = this.accountMonth;
      param.pageIndex = 1;
      param.pageSize = -1;
      param.taskTenantGuid = this.tenantGuid;
      param.isEncrypt = 'Y';
      param.tenantGuid = this.tenantGuid;
      param.curTenantGuid = localStorage.guid;
      delete param.taskDetailGuid;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/survey/report/survey-staff-page-list`, param)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableDataAll = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    emptySearch() {
      // if(!this.surveyList.length){
      //   this.$message.error('暂无问卷')
      //   return
      // }
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        surveyTenantGuid: '',
        tenantGuid: '',
        staffGuid: '',
        startTime: '',
        endTime: '',
        taskDetailGuid: '',
        accountMonth: '',
        billCycleTaskValid:'N',
        rateAdjust:'N',
      };
      this.timeRange = [];
      this.tableData = [];
      this.surveyList = [];
      this.billCycleData = [];
      // this.page.billCycle = ''
      // this.getList();
    },
    reportTopic() {
      // 导出题目
    },
    report() {
      let self = this;
      let param = JSON.parse(JSON.stringify(this.page));
      this.tableLoading = true;
      if (this.timeRange.length > 0) {
        param.startTime = this.timeRange[0];
        param.endTime = this.timeRange[1];
      }
      if (this.page.billCycle.length) {
        param.billCycle = this.page.billCycle.find((item) => item === '全部') ? [] : this.page.billCycle;
      } else {
        param.billCycle = [];
      }
      param.taskDetailGuidList = param.taskDetailGuid;
      param.accountMonth = this.accountMonth;
      param.taskTenantGuid = this.tenantGuid;
      param.pageIndex = 1;
      param.pageSize = -1;
      param.tenantGuid = this.tenantGuid;
      param.curTenantGuid = localStorage.guid;
      delete param.taskDetailGuid;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/survey/report/survey-staff-export `, param)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.reportJx(res.data.data.colNames,res.data.data.datas,res.data.data.sheetName,res.data.data.fileNam);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      this.api
        .postJsonD('/ms-common-admin-cloud-service/excel/export', {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    //新增
    addVersion() {
      let path = '/questionnaireAdd';
      let query = {};
      if (this.$route.query.productGuid) {
        query.productGuid = this.$route.query.productGuid;
      }
      this.$router.push({
        path,
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    // todo tab切换
    handleClick() {},
    // todo 退出导出模式
    goBack(res) {
      localStorage.setItem('checkboxGroupList', JSON.stringify(res.checkboxGroupList));
      this.activeName = '';
      this.$nextTick(() => {
        this.activeName = '1';
        this.$nextTick(() => {
          $eventBus.$emit('setCheckGroup', { checkboxGroupList: res.checkboxGroupList });
          this.getSurveyReport();
          this.getSurveyTaskDetail();
        });
      });
    },
  },
};
</script>


<style lang="less" scoped>
.process-list {
  background: #fff !important;
  overflow-y: auto;
}
.content h1 {
  margin: 0;
  margin-bottom: 16px;
  font-size: 18px;
}
/deep/ .el-tabs__header {
  margin: 0 0 1px;
}
/deep/ .el-tabs__nav-scroll {
  padding-left: 20px;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: #e9eef3;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/* 导入 */
.importClass .firstStep {
  text-align: left;
  margin-top: 50px;
}

.importClass .firstStep .el-row {
  margin-bottom: 50px;
}

.importClass .firstStep .el-col-6 {
  text-align: right;
}

.importClass .firstStep .tipInfo {
  line-height: 26px;
  color: #999;
  margin-top: 10px;
}

.importClass .secondStep {
  margin-top: 50px;
  height: 290px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}
.downloadTemplate {
  color: #fff;
  background: #4fa1a4;
  padding: 9px 15px;
  border-radius: 3px;
  display: inline-block;
}
.survey-state-yes {
  display: inline-block;
  width: 56px;
  height: 24px;
  color: #649fa4;
  font-size: 12px;
  background: rgba(234, 246, 247, 0.39);
  border: 1px solid #b0d0d3;
  border-radius: 2px;
}
.survey-state-no {
  display: inline-block;
  width: 56px;
  height: 24px;
  color: #ff2121;
  font-size: 12px;
  background: rgba(255, 244, 244, 0.39);
  border: 1px solid #ffdede;
  border-radius: 2px;
}
/deep/.el-progress {
  display: flex;
}
/deep/.el-progress__text {
  flex-shrink: 0;
}
.search-area .search-area-div{
  flex-shrink: 0;
  width:90px;
  text-align: right;
  margin-right: 2px;
}
.read-dialog .search-area-div{
  width:60px!important;
}
.ipt-sty{
  flex: 1;
}
.el-col-6 ,.el-col-4{
  display: flex;
  justify-content: flex-end;
  // margin-bottom: 12px;
}
.el-col-20{
  display: flex;
  justify-content: flex-start;
  // margin-bottom: 12px;
}
.el-col-8{
  display: flex;
  // margin-bottom: 15px;
  justify-content: flex-end;
}
</style>

<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.el-col-6 {
  display: flex;
}
/deep/.el-date-editor .el-range__icon {
  margin-left: 5px;
}
.no-data {
  padding: 30px;
  background: #fff;
}
</style>
